import {RecordAuditMetadataFormValue} from './recordAuditMetadataFormSchema';

// The BE participant request still requires a professionId, but the role is no longer assigned
// in the UI (the team panel shows the employee's own professions read-only). A NIL UUID is sent
// as a placeholder at this API boundary until the BE drops the field (T20-127891).
const NIL_PROFESSION_ID = '00000000-0000-0000-0000-000000000000';

// Drops blank rows (no employee picked) and maps to the BE participant shape.
export const toRecordAuditParticipants = (
  participants: RecordAuditMetadataFormValue['participants']
) =>
  participants
    .filter((participant) => participant.employeeId !== '')
    .map((participant) => ({employeeId: participant.employeeId, professionId: NIL_PROFESSION_ID}));
